import React, { Component } from 'react';
import { withTranslation, useTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { getBaseName, nl2br } from '../common/Utils';
import YearCombo from '../common/YearCombo';
import PaginateTotal from '../common/PaginateTotal';
import ReactPaginate from 'react-paginate';
import { Helmet } from 'react-helmet';
import moment from 'moment';

class AMLListPanel extends Component {
    
    constructor(props) {
        super(props);

        const { history } = this.props;
        
        if ( typeof(history.location.state) === 'undefined' ) {
            history.replace(history.location.path,{pageNo:0});
        }

        this.state = {
            query: {
                lang: props.match.params.lang,
                category: props.category,                
                year: new Date().getFullYear(),
                cntCatKeySeq: "all",
                pageNo: history.location.state['pageNo'],
                pageSize: 5,
                items: [],
                circularSubTypeList: [],
                total: 0,
                isLoading: true,
                errors: null
            }
        };
    }

    mergeQuery(updates) {
        let state = this.state;
        let mergedQuery = Object.assign({},state.query,updates);
        state.query = mergedQuery;
        return state;
    }

    async refreshTable() {
        const apiUrl = `${getBaseName()}/api/circular/search`;
        const { query } = this.state;
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(query)
        }

        let updates = {};
        try {            
            const response = await fetch(apiUrl,options);
            window.scrollTo(0, 0);
            if (response.status === 200) {
                const result = await response.json();

                //console.log(result);

                updates = {
                    items: result.items,
                    total: result.total,
                    circularSubTypeList: result.circularSubTypeList
                };
                const state = this.mergeQuery(updates);
                this.setState(state);
            } else {

            }
        } catch (error) {
            //console.log(error);
            updates = {
                errors: error
            }
        } finally {
            updates['isLoading'] = false;
            const state = this.mergeQuery(updates);
            this.setState(state);
        }

    }

    componentDidMount() {

        setTimeout(() => {this.refreshTable();},1500);

        if (typeof window.writeMenu === "function") { 
            window.writeMenu();
        }
    }

    handleYearChange(e) {
        e.preventDefault();
        const updates = { year: e.target.value, pageNo: 0 };
        const state = this.mergeQuery(updates);
        this.setState(state);
        this.refreshTable();
    }

    handleCircularSubTypeChange(e) {
        e.preventDefault();
        const updates = { cntCatKeySeq: e.target.value, pageNo: 0 };
        const state = this.mergeQuery(updates);
        this.setState(state);
        this.refreshTable();
    }

    handleSortingChange(e, field) {
        e.preventDefault();

        const original = this.state;
        let sort;
        if (field === original.query.sort.field) {
            sort = { field: field };
            if ('asc' === original.query.sort.order) {
                sort['order'] = 'desc';
            } else {
                sort['order'] = 'asc';
            }
        } else {
            sort = {
                field: field,
                order: 'asc'
            };
        }
        const updates = { sort: sort, pageNo: 0, isLoading: true };
        const state = this.mergeQuery(updates);
        this.setState(state);
        this.refreshTable();
    }

    handlePageChange(data) {
        const updates = { pageNo: data.selected, isLoading: true };

        const { history } = this.props;
        history.replace(history.location.path,{pageNo:data.selected});

        const state = this.mergeQuery(updates);
        this.setState(state);
        this.refreshTable();
    }
    
    render() {
        const { t } = this.props;
        const { query } = this.state;
        const REACT_APP_APPS_DOMAIN = `${process.env['REACT_APP_APPS_DOMAIN']}`;
        const gaScript = `
            var _gaq = _gaq || []; 
            _gaq.push(['_setAccount', '${process.env['REACT_APP_GA_ID']}']); 
            _gaq.push(['_setDomainName', '${REACT_APP_APPS_DOMAIN}']); 
            _gaq.push(['_trackPageview']); 
            
            (function () { 
            var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true; 
            ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js'; 
            var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s); 
            })();
        `;

        const ga4ScriptId = `${process.env['REACT_APP_GA4_ID']}`;

        const ga4Script = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
        
            gtag('config', '${process.env['REACT_APP_GA4_ID']}');      
        `;

        let category = this.props.category;
        category = (category === undefined)?"all":category;        

        return (
            <div style={{display:query.isLoading?"none":"block"}}>
                <Helmet>
                    <title>{t("aml.title")} | {t('common:sfc')}</title>
                    <script>{gaScript}</script>
                    <script async src={`https://www.googletagmanager.com/gtag/js?id=${ga4ScriptId}`}></script>
                    <script>{ga4Script}</script>
                </Helmet>

                <h1>
                    {t("aml.content.title")}
                </h1>
                <div dangerouslySetInnerHTML={{ __html: t("aml.content.description")}}></div>
                <br/>
                <h3>{t("aml.content.label.Filters")}</h3>
                <div className="search-section aml-circular">
                    <div>
                        <span>{t("aml.content.label.ByYear")}</span>
                        <YearCombo
                            startYear={2000}
                            year={query.year}
                            handleYearChange={this.handleYearChange.bind(this)}/>
                    </div>
                    <div>
                        <span>{t("aml.content.label.ByNature")}</span>
                        <CircularSubTypeCombo
                            list={query.circularSubTypeList}
                            cntCatKeySeq={query.cntCatKeySeq}
                            handleCircularSubTypeChange={this.handleCircularSubTypeChange.bind(this)}/>
                    </div>
                </div>
                <AMLListTable
                    showGazetteInfo={ "all" === query.cntCatKeySeq || "130" === query.cntCatKeySeq }
                    pageNo={query.pageNo} 
                    pageSize={query.pageSize} 
                    items={query.items} 
                    total={query.total}
                    handleSortingChange={this.handleSortingChange.bind(this)}
                    handlePageChange={this.handlePageChange.bind(this)}/>
            </div>
        );
    }
}

function CircularSubTypeCombo(props) {
    const { t } = useTranslation();
    const { list, cntCatKeySeq, handleCircularSubTypeChange} = props

    return (
        <select onChange={handleCircularSubTypeChange} value={cntCatKeySeq} className="default_select">
            <option key="all" value="all">{t('aml.content.label.option-all')}</option>
            {list.map((subType) => 
                <option key={subType.contentCatKeySeq} value={subType.contentCatKeySeq}>
                    {subType.catDesc}
                </option>
            )}
        </select>
    );
}

function AMLListTable(props) {
    const { t } = useTranslation();

    const { showGazetteInfo, items, pageNo, pageSize, total, handlePageChange } = props;

    const gazetteHeaders = [];
    if (showGazetteInfo) {
        gazetteHeaders.push(<th width="280px">{t('aml.table.header.noticeNumber')}</th>);
        gazetteHeaders.push(<th width="200px">{t('aml.table.header.gazettalDate')}</th>);
    }
    return (
        <div className="table-container main-style circular-aml-table">
            <table>
                <tbody>
                    <tr>
                        <th width="200px">
                            <Link onClick={(e) => { props.handleSortingChange(e,'issueDate'); }}>
                                {t('aml.table.header.releasedDate')}
                            </Link>
                        </th>
                        <th>
                            <Link onClick={(e) => { props.handleSortingChange(e,'publication'); }}>
                                {t('aml.table.header.title')}
                            </Link>
                        </th>
                        {gazetteHeaders}
                    </tr>
                {items.map((circular) => {
                    if (showGazetteInfo) {
                        return (
                            <tr key={circular.refNo}>
                                <td>
                                    {t('common:date.formatter',{date: moment(circular.releasedDate, "YYYY-MM-DDTHH:mm:ss").toDate()})}
                                </td>
                                <PublicationColumn circular={circular}/>
                                <NoticeNumberColumn circular={circular}/>
                                <GazettalDateColumn circular={circular}/>
                            </tr>
                        );
                    } else {
                        return (
                            <tr key={circular.refNo}>
                                <td>
                                    {t('common:date.formatter',{date: moment(circular.releasedDate, "YYYY-MM-DDTHH:mm:ss").toDate()})}
                                </td>
                                <PublicationColumn circular={circular}/>
                            </tr>
                        );
                    }
                })}
                </tbody>
            </table>
            <div className="pagination-toolbar">
                <PaginateTotal pageNo={pageNo} pageSize={pageSize} total={total} />
                <div className="pagination-toolbar pagebar">
                    <ReactPaginate
                        previousLabel="<"
                        nextLabel=">"
                        breakLabel={'. . .'}                                        
                        marginPagesDisplayed={1}
                        pageRangeDisplayed={7}
                        initialPage={pageNo}
                        disableInitialCallback={true}
                        pageCount={Math.ceil(total/pageSize)}
                        onPageChange={handlePageChange}
                        containerClassName={'pagination'}
                        previousClassName={'previous'}
                        breakClassName={'break'}
                        pageClassName={'page'}
                        activeClassName={'active'}
                        nextClassName={'next'}/>
                </div>                        
            </div>
        </div>
    );
}

function PublicationColumn(props) {
    const { t } = useTranslation();
    const { circular } = props;
    const docUrl = `doc?refNo=${circular.refNo}`;

    const columnContent = [];
    columnContent.push(<Link to={docUrl} dangerouslySetInnerHTML={{ __html:nl2br(circular.title)}}></Link>);
    if ( Array.isArray(circular.appendixDocList) && circular.appendixDocList.length>0 ) {
        columnContent.push(
            circular.appendixDocList.map((appendix) => 
                <li>
                    <Link to={`openAppendix?refNo=${circular.refNo}&appendix=${appendix.refNo}`}>
                        {nl2br(appendix.caption)}
                    </Link>
                </li>
            )
        );
    }
    return (<td>{columnContent}</td>);
}

function NoticeNumberColumn(props) {
    const { circular } = props;

    if ( Array.isArray(circular.gazettalNoticeList) && circular.gazettalNoticeList.length>0 && (
        circular.gazettalNoticeList[0].noticeContent!==null
    )) {
        return (
            <td>
            {circular.gazettalNoticeList.map((notice) => {
                if ( notice.noticeContent !== null ) {
                    const rtn = [];
                    rtn.push(<br/>);
                    if (notice.hasNoticeURL) {
                        rtn.push(
                            <a href={notice.noticeURL}>
                                {notice.noticeContent}
                            </a>
                        );
                    } else {
                        rtn.push(
                            notice.noticeContent
                        );
                    }
                    return rtn;
                }
            })}
            </td>
        );
    } else {
        return (<td>N/A</td>);
    }
}

function GazettalDateColumn(props) {
    const { t } = useTranslation();
    const { circular } = props;

    if ( Array.isArray(circular.gazettalNoticeList) && circular.gazettalNoticeList.length>0  && (
        circular.gazettalNoticeList[0].noticeContent!==null
    )) {
        return (
            <td>
            {circular.gazettalNoticeList.map((notice) => {
                if ( notice.noticeContent !== null ) {
                    const rtn = [];
                    rtn.push(<br/>);
                    if(notice.gazettalDate !== null){
                        rtn.push(
                            t('common:date:formatter',{ date: moment(notice.gazettalDate, "YYYY-MM-DDTHH:mm:ss").toDate()})
                        );
                    }
                    else{
                        rtn.push(
                            "N/A"
                        );
                    }
                    return rtn;
                }                
            })}
            </td>
        );
    } else {
        return (<td>N/A</td>);
    }
}

export default withRouter(withTranslation()(AMLListPanel));